export default "__VITE_ASSET__C9sGj03o__"